<template>
   <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeTypeOt.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button
                class="button is-addOrEdit"
                @click="checkPermissions(constantes.TYPE_OT.maj)
                       ? $router.push({name: 'm.logistique.type_ot-ajout'})
                       : showPopUp()"
                :class="{ 'button-access-no-permission' :
                 !checkPermissions(constantes.TYPE_OT.maj) }">
                {{ $t('listeTypeOt.actions.add')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-12">
            <b-input :placeholder="$t('general.autocomplete.search')"
                     type="search" icon="magnify" v-model="critereRecherche.auto">
            </b-input>
          </form>

          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}</span>
            </button>
            <div class="info-circle-right background-primary is-pulled-right"
                 v-if="nombreCritere > 0">
              <span class="inside-circle">{{ nombreCritere }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.TYPE_OT.exporter"
            in-progress/>
        </div>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" ref="tableTypeOt"
                    @loaded="finLoading" @loading="debutLoading">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableTypeOt.setLimit($event)"/>
      </template>
      <div slot="libelle" slot-scope="props">
          <b-icon
            v-if="moduleImpressionActive && props.row.couleur"
            icon="checkbox-blank-circle"
            size="is-small"
            class="mgr-5px"
            :style="getCouleurStyle(props.row)">
          </b-icon>
          <router-link :class="{'text-access-no-permission':
                       !checkPermissions(constantes.TYPE_OT.lecture)}"
                       :to="{ name: 'c.logistique.type_ot', params: {id: props.row.id}}">
            <a class='lien'>{{props.row.libelle}}</a>
          </router-link>
      </div>
      <div slot="actionInterventionOt" slot-scope="props">
        {{ getActionIntervention(props.row.actionInterventionOt) }}
      </div>
      <div slot="produit" slot-scope="props">
        <b-tooltip  v-if="props.row.produitId"
                    :label="props.row.produit.libelle"
                    position="is-left">
           {{props.row.produit.reference}}
        </b-tooltip>
      </div>
      <div slot="taches" slot-scope="props" class="has-text-right">
        <b-tooltip :active="!!props.row.tachesTypeOt.length"
                    position="is-right"
                    class="max-width-165">
          <template v-slot:content>
              <div v-for="(tache,i) in props.row.tachesTypeOt" :key="i">
                <p>{{tache.libelle}}</p>
              </div>
            </template>
          {{ props.row.tachesTypeOt.length }}
        </b-tooltip>
      </div>
      <template slot="isVisibleInSuiviProduction" slot-scope="props">
        {{ props.row.isVisibleInSuiviProduction ? $t('general.oui') : $t('general.non')  }}
      </template>
      <div slot="edit" slot-scope="props">
        <div
          @click="checkPermissions(constantes.TYPE_OT.maj)
                 ? $router.push({name: 'm.logistique.type_ot-edit', params: { id: props.row.id }})
                 : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            icon="pencil-box-outline"
            type="is-success"
            :class="{ 'text-access-no-permission' : !checkPermissions(constantes.TYPE_OT.maj) }">
          </b-icon>
        </div>
      </div>
      <div slot="delete" slot-scope="props">
        <div @click="checkPermissions(constantes.TYPE_OT.supprimer) ? openPopUpDelete(props.row) :
            showPopUp()"
             class="is-cursor-pointer">
          <b-icon type="is-danger" icon="delete-forever" :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.TYPE_OT.supprimer) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <div class="componentBrief" v-if="showFiltre === true">
      <filtre-type-ot v-if="showFiltre === true"
                       @toggleFiltre="setShowFiltre"
                       @recherche="makeRechercheFilter"/>
    </div>
     <b-modal v-model="popUpSuppression" has-modal-card class="modal">
       <pop-up-prevention
         :messagesPopup="messagesErreurPopUp"
         :isErrorPopup.sync="errorPopUp"
         :messHeader="$t('listeTypeOt.popUpSuppression.title')"
         :cancel="$t('general.non')"
         :validate="$t('general.oui')"
         @no="popUpSuppression = false"
         @yes="deleteTypeOt"/>
     </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import { TYPE_OT } from '@/configuration/logistique/permissionsLogistiqueConf';
import {
  LISTE_ACTION_INTERVENTION,
  LISTE_ACTION_INTERVENTION_IPRESSIONAFFICHE,
  LISTE_ACTION_INTERVENTION_DISPOSITF,
} from '@/configuration/logistique/typeOt/typeOtConfig';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE,
} from '@/configuration/clientTableConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import TableItemsInView from '@/components/general/TableItemsInView';
import FiltreTypeOt from '@/components/logistique/typeOt/filtreTypeOt';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import popUpPrevention from '@/components/general/popUpPrevention';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { deleteTypeOt } from '@/api/typeOt';
import messageSucces from '@/services/general/messageSucces';
import { validationSuppression } from '@/services/logistique/typeOt/validation';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { columnsSplice } from '@/services/general/columns';

const TypeOt = createNamespacedHelpers('typeOt');
const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      constantes: {
        TYPE_OT,
      },
      unsubscribeValue: null,
      showFiltre: false,
      popUpSuppression: false,
      messagesErreurPopUp: [],
      errorPopUp: false,
      idToDelete: false,
    };
  },
  components: {
    breadcrumb,
    TableItemsInView,
    FiltreTypeOt,
    popUpPrevention,
    exportExcelButton,
  },
  computed: {
    ...TypeOt.mapGetters({
      items: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    moduleImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$i18n.t('listeTypeOt.breadcrumb.listeTypeOt'), route: '', isActive: true },
      ];
      return output;
    },
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeTypeOt.tab.type'),
          actionInterventionOt: this.$t('listeTypeOt.tab.actionIntervention'),
          produit: this.$t('listeTypeOt.tab.produit'),
          taches: this.$t('listeTypeOt.tab.taches'),
          isVisibleInSuiviProduction: this.$t('listeTypeOt.tab.isVisibleInSuiviProduction'),
          edit: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = {
            auto: this.critereRecherche.auto,
            societeId: this.societeActiveId,
            produitIds: this.critereRecherche.produits.map(el => el.id),
            actionsInterventionsOt: this.critereRecherche.actionsInterventionsOt,
            types: this.critereRecherche.types,
          };
          return this.actionLoadTypeOt(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          delete: 'colonneSelected',
        },
        sortable: (() => {
          const cols = ['libelle', 'actionInterventionOt', 'produit', 'isVisibleInSuiviProduction'];
          if (!this.moduleImpressionActive) {
            columnsSplice(cols, 'isVisibleInSuiviProduction');
          }
          return cols;
        })(),
      };
    },
    columns() {
      const cols = ['libelle', 'actionInterventionOt', 'produit', 'taches',
        'isVisibleInSuiviProduction', 'edit', 'delete'];
      if (!this.moduleImpressionActive) {
        columnsSplice(cols, 'isVisibleInSuiviProduction');
      }
      return cols;
    },
    nombreCritere() {
      const critereBan = ['auto', 'societeId'];
      const nombreCritere = calculNombreCritere(this.critereRecherche, critereBan);
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
  },
  methods: {
    ...TypeOt.mapActions({
      actionLoadTypeOt: 'loadTypeOt',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
      loadParametresInterne: 'loadParametresInterne',
    }),
    openPopUpDelete(typeOt) {
      this.popUpSuppression = true;
      this.idToDelete = typeOt.id;
    },
    async deleteTypeOt() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreurPopUp = [];
        this.errorPopUp = false;
        await deleteTypeOt(this.idToDelete);
        messageSucces(this.$t('listeTypeOt.messages.success.typeOtDelete'));
        this.popUpSuppression = false;
        await this.loadParametreForce(PARAMETRES_KEYS.typeOt);
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          validationSuppression(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs.tableTypeOt.refresh();
    },
    goFirstPage() {
      this.$refs.tableTypeOt.setPage(1);
    },
    getActionIntervention(action) {
      let interventionsActions = LISTE_ACTION_INTERVENTION;
      if (this.moduleStockTiersActive) {
        interventionsActions = interventionsActions
          .concat(LISTE_ACTION_INTERVENTION_IPRESSIONAFFICHE);
      }
      if (this.moduleEmplacementClientActive) {
        interventionsActions = interventionsActions
          .concat(LISTE_ACTION_INTERVENTION_DISPOSITF);
      }
      const actionFind = interventionsActions.find((actionInter) => {
        return actionInter.code === action;
      });
      return actionFind ? this.$i18n.t(actionFind.libelle) : '';
    },
    makeRechercheFilter() {
      this.setShowFiltre();
      this.recherche();
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      this.setLockMenu(!this.lockMenu);
    },
    getCouleurStyle(row) {
      return `color: ${row.couleur}`;
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
        PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
        PARAMETRES_INTERNE_KEYS.demandeImpression.key,
      ]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageLogistique.typeOt.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style>

</style>
